import { Phone, Video } from 'lucide-react';
import type { CallMode } from '../services/callApi';

type CallButtonsProps = {
  disabled?: boolean;
  onStart: (mode: CallMode) => void;
};

export function CallButtons({ disabled = false, onStart }: CallButtonsProps) {
  return (
    <div className="call-buttons" aria-label="Private calls">
      <button className="secondary-button full-width" type="button" disabled={disabled} onClick={() => onStart('voice')}>
        <Phone size={18} aria-hidden="true" />
        Voice Call
      </button>
      <button className="secondary-button full-width" type="button" disabled={disabled} onClick={() => onStart('video')}>
        <Video size={18} aria-hidden="true" />
        Video Call
      </button>
    </div>
  );
}
